// extracted by mini-css-extract-plugin
export default {"SliderWrapper":"SlickSliderCaregiving_SliderWrapper__buwUE"};